module.exports = __webpack_public_path__ + "static/media/parceiro(7).b2252f07.png";